

import { atom , useRecoilValue, useSetRecoilState, useResetRecoilState} from "recoil";


const stockAtomList = atom({key:'stockAtom', default:{stock_info:[],
    Warehouse:[]
}});

const stockEditAtom = atom({key:'stockAtomEdit', default:{adjustment_main: [],
    adjustment_details: []}});




export  const SetStockList = () => useSetRecoilState(stockAtomList);
export  const GetStockList = () => useRecoilValue(stockAtomList);

export  const SetStockEdit = () => useSetRecoilState(stockEditAtom);
export  const GetStockEdit = () => useRecoilValue(stockEditAtom);








